import * as types from './types'
// import storage from '@/plugins/storage'
import globals from '@/plugins/globals'

export default {
  [types.SET_CRITERIA_CHANGED](state, value) {
    state.criteriaChanged = value
  },
  [types.SET_STEP](state, data) {
    state.step = data
  },
  [types.SET_VISITED_STEP](state, currentStep) {
    state.visitedStep = currentStep > state.visitedStep ? currentStep : state.visitedStep
  },
  [types.RESET_VISITED_STEP](state, data) {
    state.visitedStep = data
  },
  [types.PREP_RECOMMENDATION](state, firm) {
    state.recommendation.firm = firm
    state.recommendation.testDriveRecommendation = null
  },
  [types.SET_RECOMMENDATIONS](state, data) {
    state.recommendations = data
  },
  [types.SET_RECOMMENDATION](state, data) {
    state.recommendation = data
  },
  [types.RESET_TRANSLATIONS](state, data) {
    state.translations = []
  },
  [types.SET_TRANSLATIONS](state, data) {
    state.translations = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.translations = data
      }
    }
  },
  [types.RESET_RESULTTYPE](state) {
    state.testdriveResultType = JSON.parse(JSON.stringify(state.newResultType))
  },
  [types.SET_RESULTTYPES](state, data) {
    state.testdriveResultTypes = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.testdriveResultTypes = data
      }
    }
  },
  [types.SET_RESULTTYPE](state, data) {
    state.testdriveResultType = JSON.parse(JSON.stringify(state.newResultType))
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.testdriveResultType = data[0]
      }
    }
  },
  [types.UPDATE_RESULTTYPE](state, data) {
    if (state.testdriveResultType !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.testdriveResultType.firm = parseInt(data.value)
          break
        case 'year':
          if (data.value === null || data.value === '') {
            state.testdriveResultType.year = null
          } else {
            state.testdriveResultType.year = parseInt(data.value)
          }
          break
        case 'vehicleMake':
          if (data.value === null || data.value === '') {
            state.testdriveResultType.vehicleMake = [null]
          } else {
            state.testdriveResultType.vehicleMake = parseInt(data.value)
          }
          break
        case 'driveType':
          if (data.value === null || data.value === '') {
            state.testdriveResultType.driveType = null
          } else {
            state.testdriveResultType.driveType = parseInt(data.value)
          }
          break
        case 'testdriveResultTypeName':
          state.testdriveResultType.testdriveResultTypeName = data.value
          break
        case 'testdriveResultCode':
          state.testdriveResultType.testdriveResultCode = data.value
          break
      }
    }
  },
  [types.SET_MATRIX_CATEGORIES](state, data) {
    state.adasMakeMatrixCategories = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasMakeMatrixCategories = data
      }
    }
    console.log('Got ADAS Make Matrix categories', state.adasMakeMatrixCategories)
  },
  [types.SET_MATRIX_SUBCATEGORIES](state, data) {
    state.adasMakeMatrixSubCategories = null
    console.log("types.SET_MATRIX_SUBCATEGORIES: ", data)
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasMakeMatrixSubCategories = data
      }
    }
    console.log('Set ADAS Make Matrix Sub Categories', state.adasMakeMatrixSubCategories)
  },
  [types.INIT_ADAS_MATRIX](state) {
    state.adasmatrix = JSON.parse(JSON.stringify(state.newadasmatrix))
  },
  [types.UPDATE_ADAS_MATRIX](state, data) {
    // console.log('Update ADAS Matrix', {
    //   matrix: state.adasmatrix,
    //   data: data
    // })
    if (state.adasmatrix !== null && data !== null) {
      switch (data.name) {
        case 'matrixItem':
          state.adasmatrix.matrixItem = data.value
          break
        case 'sort':
          state.adasmatrix.sort = parseInt(data.value)
          break
        case 'isInactive':
          state.adasmatrix.isInactive = data.value
          break
        case 'isHighlight':
          state.adasmatrix.isHighlight = data.value
          break
        case 'notice':
          state.adasmatrix.notice = data.value
          break
        case 'hints':
          state.adasmatrix.hints = data.value
          break
        case 'keywords':
          state.adasmatrix.keywords = data.value
          break
      }
    }
  },
  [types.SET_ADAS_MATRIX](state, id) {
    let cnt = 0
    state.adasmatrix = JSON.parse(JSON.stringify(state.newadasmatrix))
    let found = state.adasmatrices.find((x) => parseInt(x.adasChecklistMatrix) === parseInt(id))
    if (found !== undefined && found !== null) {
      state.adasmatrix = JSON.parse(JSON.stringify(found))
      if (state.adasmatrix.items !== null) {
        state.adasmatrix.items.forEach((element) => {
          element.id = cnt
          element.isRemove = false
          cnt++
        })
      } else {
        state.adasmatrix.items = []
      }
    }
  },
  [types.UPDATE_ADAS_MATRIXITEM](state, data) {
    if (state.adasmatrix !== null && data !== null) {
      let lastId = 0
      let found = null
      if (state.adasmatrix.items.length > 0) {
        lastId = state.adasmatrix.items[state.adasmatrix.items.length - 1].id + 1
      }
      switch (data.action) {
        case 'add':
          state.adasmatrix.items.push({
            id: lastId,
            adasChecklistMatrixItem: null,
            adasChecklistMatrix: state.adasmatrix.adasChecklistMatrix,
            isRemove: false,
            item: data.value
          })
          break
        case 'save':
          found = state.adasmatrix.items.find((x) => parseInt(x.id) === parseInt(data.id))
          if (found !== undefined && found !== null) {
            found.item = data.value
          }
          break
        case 'remove':
          found = state.adasmatrix.items.find((x) => parseInt(x.id) === parseInt(data.id))
          if (found !== undefined && found !== null) {
            found.isRemove = true
          }
          break
      }
    }
  },
  [types.SET_ADAS_EXCLUSIONS](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.exclusions = data
      }
    }
  },
  [types.RESET_ADAS_MATRICES](state, data) {
    state.adasmatrices = []
  },
  [types.SET_ADAS_MATRICES](state, data) {
    state.adasmatrices = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasmatrices = data
        // console.log('Storing to Session', state.adasmatrices)
        // storage.session.setItem(types.SESSION_ADAS_MATRIX, JSON.stringify(state.adasmatrices))
      }
    }
  },
  [types.SET_DECODED_VIN](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.decodedVin = data
      }
    }
  },
  [types.RESET_DECODED_ALT_VIN](state) {
    state.decodedAltVin = []
  },
  [types.SET_DECODED_ALT_VIN](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.decodedAltVin = data
      }
    }
  },
  [types.INIT_ADAS_MAKE_MATRIX](state) {
    state.adasmakematrix = JSON.parse(JSON.stringify(state.newadasmakematrix))
    // console.log('A new ADAS Make Matrix', state.adasmakematrix)
  },
  [types.UPDATE_ADAS_MAKE_MATRIX](state, data) {
    if (state.adasmakematrix !== null && data !== null) {
      console.log('Updating ADAS Make Matrix', data)
      switch (data.name) {
        case 'id':
          state.adasmakematrix.adasChecklistMatrixVehicle = parseInt(data.value)
          state.adasmakematrix.id = parseInt(data.value)
          break
        case 'adasChecklistMatrix':
          state.adasmakematrix.adasChecklistMatrix = parseInt(data.value)
          break
        case 'make':
          state.adasmakematrix.vehicleMake = parseInt(data.value)
          break
        case 'model':
          state.adasmakematrix.vehicleModel = data.value
          break
        case 'yearStart':
          state.adasmakematrix.yearStart = parseInt(data.value)
          break
        case 'yearEnd':
          state.adasmakematrix.yearEnd = parseInt(data.value)
          break
        case 'systemType':
          state.adasmakematrix.systemType = data.value
          break
        case 'locationType':
          state.adasmakematrix.locationType = data.value
          break
        case 'system':
          state.adasmakematrix.system = data.value
          break
        case 'location':
          state.adasmakematrix.location = data.value
          break
        case 'isRR':
          state.adasmakematrix.isRR = data.value
          break
        case 'isRI':
          state.adasmakematrix.isRI = data.value
          break
        case 'calibrationType':
          state.adasmakematrix.calibrationType = parseInt(data.value)
          break
        case 'calibrationSubTypes':
          state.adasmakematrix.calibrationSubTypes = data.value
          break
        case 'url':
          state.adasmakematrix.url = data.value
          break
        case 'isInactive':
          state.adasmakematrix.isInactive = data.value
          break
        case 'sort':
          state.adasmakematrix.sort = parseInt(data.value)
          break
        case 'source':
          state.adasmakematrix.source = data.value
          break
        case 'systemLookup':
          state.adasmakematrix.systems.push(data.value)
          break
        case 'removeSystem':
          state.adasmakematrix.systems = state.adasmakematrix.systems.filter((el) => {
            return el !== data.value
          })
          break
        case 'locationLookup':
          state.adasmakematrix.locations.push(data.value)
          break
        case 'removeLocation':
          state.adasmakematrix.locations = state.adasmakematrix.locations.filter((el) => {
            return el !== data.value
          })
          break
        case 'staticLookup':
          state.adasmakematrix.static.push(data.value)
          break
        case 'removeStatic':
          state.adasmakematrix.static = state.adasmakematrix.static.filter((el) => {
            return el !== data.value
          })
          break
        case 'dynamicLookup':
          state.adasmakematrix.dynamic.push(data.value)
          break
        case 'removeDynamic':
          state.adasmakematrix.dynamic = state.adasmakematrix.dynamic.filter((el) => {
            return el !== data.value
          })
          break
        case 'triggerNotice':
          state.adasmakematrix.triggerNotice = data.value
          break
        case 'triggerNoticeText':
          state.adasmakematrix.triggerNoticeText = data.value
          break
        case 'addCccLocationKeyword':
          let found = state.adasmakematrix.cccLocationKeywords.find((x) => x === data.value)
          if (!found) {
            state.adasmakematrix.cccLocationKeywords.push(data.value)
          }
          break
        case 'removeCccLocationKeyword':
          state.adasmakematrix.cccLocationKeywords = state.adasmakematrix.cccLocationKeywords.filter((el) => {
            return el !== data.value
          })
          break
        case 'addCccLineKeyword':
          state.adasmakematrix.cccLineKeywords.push(data.value)
          break
        case 'removeCccLineKeyword':
          state.adasmakematrix.cccLineKeywords = state.adasmakematrix.cccLineKeywords.filter((el) => {
            return el !== data.value
          })
          break
        case 'addCccSubletKeyword':
          state.adasmakematrix.cccSubletKeywords.push(data.value)
          break
        case 'removeCccSubletKeyword':
          state.adasmakematrix.cccSubletKeywords = state.adasmakematrix.cccSubletKeywords.filter((el) => {
            return el !== data.value
          })
          break
        case 'addModelVariability': {
          let id = 0
          if (state.adasmakematrix.models === undefined || state.adasmakematrix.models === null) {
            state.adasmakematrix.models = []
          }
          state.adasmakematrix.models.forEach((element) => {
            if (element.id < id) {
              id = element.id
            }
          })
          let found = state.adasmakematrix.models.find((x) => x.name.trim().toUpperCase() === data.value.trim().toUpperCase())
          if (!found) {
            id -= 1
            let model = {
              id: id,
              name: data.value.trim(),
              isAdd: true,
              isDelete: false
            }
            state.adasmakematrix.models.push(model)
          }
          break
        }
        case 'removeModelVariability':
          let temp = state.adasmakematrix.models.find((x) => parseInt(x.id) === parseInt(data.value))
          if (temp) {
            temp.isDelete = true
          }
        // state.adasmakematrix.models = state.adasmakematrix.models.filter((el) => {
        //   return parseInt(el.id) !== parseInt(data.value)
        // })
      }
    }
    console.log('Updated ADAS Make Matrix', state.adasmakematrix)
  },
  [types.INIT_ADAS_MATRIX_INFO_LOOKUP](state) {
    if (state != null && state.newadasmatrixinfolookup != null) {
      state.adasmatrixinfolookup = JSON.parse(JSON.stringify(state.newadasmatrixinfolookup))
      console.log('A new ADAS Matrix Info Lookup', state.adasmatrixinfolookup)
    }
  },
  [types.UPDATE_ADAS_MATRIX_INFO_LOOKUP](state, data) {
    if (state.adasmatrixinfolookup !== null && data !== null) {
      // console.log('Updating ADAS Matrix Info Lookup', data)
      switch (data.name) {
        case 'id':
          state.adasmatrixinfolookup.adasChecklistMatrixInfoLookup = null
          state.adasmatrixinfolookup.id = null
          if (data.value !== null) {
            state.adasmatrixinfolookup.adasChecklistMatrixInfoLookup = parseInt(data.value)
            state.adasmatrixinfolookup.id = parseInt(data.value)
          }
          break
        case 'adasChecklistMatrix':
          state.adasmatrixinfolookup.adasChecklistMatrix = null
          if (data.value !== null) {
            state.adasmatrixinfolookup.adasChecklistMatrix = parseInt(data.value)
          }
          break
        case 'make':
          state.adasmatrixinfolookup.vehicleMake = parseInt(data.value)
          break
        case 'yearStart':
          state.adasmatrixinfolookup.yearStart = parseInt(data.value)
          break
        case 'yearEnd':
          state.adasmatrixinfolookup.yearEnd = parseInt(data.value)
          break
        case 'keywords':
          state.adasmatrixinfolookup.keywords = data.value
          break
        case 'lookupType':
          state.adasmatrixinfolookup.lookupType = parseInt(data.value)
          break
        case 'url':
          state.adasmatrixinfolookup.url = data.value
          break
        case 'isInactive':
          state.adasmatrixinfolookup.isInactive = data.value
          break
        case 'sort':
          state.adasmatrixinfolookup.sort = parseInt(data.value)
          break
        case 'source':
          state.adasmatrixinfolookup.source = data.value
          break
        case 'isReportAdd':
          state.adasmatrixinfolookup.isReportAdd = data.value
          break
        case 'description':
          state.adasmatrixinfolookup.description = data.value
          break
      }
    }
    // console.log('Updated ADAS Matrix Info Lookup', state.adasmatrixinfolookup)
  },
  [types.SET_ADAS_MAKE_MATRICES](state, data) {
    state.adasmakematrices = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasmakematrices = data
      }
    }
  },
  [types.SET_ADAS_MAKE_MATRIX_ID](state, data) {
    if (data !== undefined && data !== null) {
      state.adasmakematrix.adasChecklistMatrixVehicle = parseInt(data)
      state.adasmakematrix.id = parseInt(data)
    }
  },
  [types.SET_ADAS_MAKE_MATRIX](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        console.log("SET_ADAS_MAKE_MATRIX:", data)
        state.adasmakematrix = JSON.parse(JSON.stringify(data))

        console.log("SET_ADAS_MAKE_MATRIX state.adasmakematrix:", state.adasmakematrix)
        state.adasmakematrix.systems = []
        if (data.systems !== undefined && data.systems !== null) {
          data.systems.forEach((element) => {
            state.adasmakematrix.systems.push(element.name)
          })
        }
        state.adasmakematrix.locations = []
        if (data.locations !== undefined && data.locations !== null) {
          data.locations.forEach((element) => {
            state.adasmakematrix.locations.push(element.name)
          })
        }
        state.adasmakematrix.static = []
        if (data.static !== undefined && data.static !== null) {
          data.static.forEach((element) => {
            state.adasmakematrix.static.push(element.name)
          })
        }
        state.adasmakematrix.dynamic = []
        if (data.dynamic !== undefined && data.dynamic !== null) {
          data.dynamic.forEach((element) => {
            state.adasmakematrix.dynamic.push(element.name)
          })
        }
        state.adasmakematrix.cccLocationKeywords = []
        if (data.cccLocationKeywords !== undefined && data.cccLocationKeywords !== null) {
          if (data.cccLocationKeywords !== '') {
            state.adasmakematrix.cccLocationKeywords = data.cccLocationKeywords.split(',')
          }
        }
        state.adasmakematrix.cccLineKeywords = []
        if (data.cccLineKeywords !== undefined && data.cccLineKeywords !== null) {
          if (data.cccLineKeywords !== '') {
            state.adasmakematrix.cccLineKeywords = data.cccLineKeywords.split(',')
          }
        }
        state.adasmakematrix.cccSubletKeywords = []
        if (data.cccSubletKeywords !== undefined && data.cccSubletKeywords !== null) {
          if (data.cccSubletKeywords !== '') {
            state.adasmakematrix.cccSubletKeywords = data.cccSubletKeywords.split(',')
          }
        }
        console.log('Got ADAS Make Matrix', state.adasmakematrix)
      }
    }
  },
  [types.SET_ADAS_MATRIX_INFO_LOOKUPS](state, data) {
    state.adasmatrixinfolookups = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasmatrixinfolookups = data
      }
    }
  },
  [types.SET_ADAS_MATRIX_INFO_LOOKUP](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.adasmatrixinfolookup = JSON.parse(JSON.stringify(data))
      }
    }
  },
  [types.SET_ADAS_MATRIX_INFO_ID](state, data) {
    if (data !== undefined && data !== null) {
      state.adasmatrixinfolookup.adasChecklistMatrixInfoLookup = parseInt(data)
      state.adasmatrixinfolookup.id = parseInt(data)
    }
  },
  [types.SET_ADAS_LINK](state, data) {
    if (data.name === 'linkAdd') {
      let newAdasLink = {
        id: parseInt(data.value.id),
        title: data.value.title,
        url: data.value.url,
        type: data.value.type,
        year: data.value.year,
        model: data.value.model,
        isNew: true
      }
      // id where to place the new link
      let titleItems = data.value.title.split('>>')
      let idx = null
      if (titleItems.length > 0) {
        titleItems.forEach((title) => {
          state.adasLinks.forEach((link, index) => {
            let linkTitleItems = link.title.split('>>')
            if (linkTitleItems.length > 0) {
              linkTitleItems.forEach((linkTitle) => {
                if (title.trim() === linkTitle.trim()) {
                  idx = index
                }
              })
            }
          })
        })
      }
      if (idx) {
        state.adasLinks.splice(idx + 1, 0, newAdasLink)
      } else {
        state.adasLinks.push(newAdasLink)
      }
    } else if (data.name === 'linkRemove') {
      state.adasLinks = state.adasLinks.filter((el) => {
        return parseInt(el.id) !== parseInt(data.value)
      })
    }
    // Process the links
    let newLinks = JSON.parse(JSON.stringify(state.linksDefault))
    let newLink = JSON.parse(JSON.stringify(state.linkDefault))
    if (state.adasLink) {
      if (state.adasLink.carid !== null) {
        newLinks._embedded.data.GEN3NA._embedded.data.dataSource.name = 'gen3NAData'
      }
      newLink.groupCategory.id = state.adasLink.adasChecklistMatrixVehicle
      newLink.groupCategory.name = state.adasLink.adasChecklistMatrixName
    }
    state.adasLinks.forEach((link) => {
      newLink.results.push({
        display: link.title,
        isOpus: true,
        isNew: link.isNew,
        type: link.type,
        year: link.year,
        model: link.model,
        _links: {
          self: {
            href: link.url
          }
        }
      })
    })
    newLinks._embedded.data.GEN3NA._embedded.data.results.push(newLink)
    newLinks._embedded.data.GEN3NA._embedded.data.results[0].results = globals.sortArray(
      newLinks._embedded.data.GEN3NA._embedded.data.results[0].results,
      'display'
    )
    state.adasLink.links = JSON.stringify(newLinks)
  },
  [types.REMOVE_ADAS_LINKS](state, links) {
    links.adasLinks.forEach((element) => {
      state.adasmakematrix.links = state.adasmakematrix.links.filter((el) => {
        return parseInt(el.adaslinks) !== parseInt(element.adasLink)
      })
    })
  },
  [types.RESET_ADAS_LINKS](state) {
    state.adasLinks = []
  },
  [types.SET_ADAS_LINKS](state, data) {
    state.adasLink = null
    state.adasLinks = []
    let cnt = 1
    if (data !== undefined && data !== null) {
      state.adasLink = data
      if (data.links) {
        let parsed = null
        if (globals.isJson(data.links)) {
          parsed = JSON.parse(data.links)
          if (parsed._embedded.data.GEN3NA._embedded.data) {
            if (parsed._embedded.data.GEN3NA._embedded.data.results) {
              parsed._embedded.data.GEN3NA._embedded.data.results.forEach((element) => {
                element.results.forEach((link) => {
                  state.adasLinks.push({
                    id: cnt,
                    title: link.display,
                    url: link._links.self.href,
                    isNew: false
                  })
                  cnt++
                })
              })
            }
          }
        } else {
          state.adasLinks.push({
            id: cnt,
            title: '',
            url: data.links,
            isNew: false
          })
          cnt++
        }
      }
    }
    console.log('Got ADAS Link', state.adasLink)
  },
  [types.SET_MAKE_EXCEPTIONS](state, data) {
    state.makeExceptions = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.makeExceptions = data
      }
    }
    console.log('Got Make Exceptions', state.makeExceptions)
  },
  [types.SET_MATRIX_KEYWORDS_TRIGGERS](state, data) {
    state.matrixKeywordsTriggers = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.matrixKeywordsTriggers = data
      }
    }
  },
  [types.SET_MATRIX_ADAS_INFO](state, data) {
    state.matrixAdasInfo = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.matrixAdasInfo = data
      }
    }
  },
  [types.SET_MAKE_EXCEPTION_LOOKUPS](state, data) {
    state.makeExceptionLookups = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.makeExceptionLookups = data
      }
    }
  },
  [types.SET_MODEL_VARIABILITY](state, data) {
    if (state.adasmakematrix) {
      state.adasmakematrix.models = data
    }
  },
  [types.UPDATE_NOSCRUB_DATA](state, data) {
    switch (data.name) {
      case 'new':
        state.noScrubItem = JSON.parse(JSON.stringify(state.newNoScrubItem))
        break
      case 'vehicleMake':
        state.noScrubItem.vehicleMake = parseInt(data.value)
        break
      case 'vehicleModel':
        state.noScrubItem.vehicleModel = data.value
        break
      case 'model':
        state.noScrubItem.model = data.value
        break
      case 'yearStart':
        state.noScrubItem.yearStart = parseInt(data.value)
        break
      case 'yearEnd':
        state.noScrubItem.yearEnd = parseInt(data.value)
        break
      case 'reason':
        state.noScrubItem.reason = data.value
        break
      case 'isInactive':
        state.noScrubItem.isInactive = data.value
        break
    }
  },
  [types.SET_NOSCRUBLIST](state, data) {
    state.noScrubList = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.noScrubList = data
      }
    }
    console.log('Got No Scrub List', state.noScrubList)
  },
  [types.SET_NOSCRUB](state, id) {
    state.noScrubItem = null
    console.log('Looking for No Scrub Item', id)
    if (state.noScrubList) {
      let found = state.noScrubList.find((x) => parseInt(x.adasNoScrubList) === parseInt(id))
      if (found) {
        state.noScrubItem = found
      }
    }
    console.log('Found No Scrub Item', state.noScrubItem)
  },
  [types.RESET_CALIBRATIONS](state) {
    state.systemCalibrations = []
  },
  [types.RESET_PRICING](state) {
    state.calibrationPricing = []
  },
  [types.SET_SYSTEM_CALIBRATIONS](state, data) {
    state.systemCalibrations = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.systemCalibrations = data
      }
    }
    console.log('Got System Calibrations', state.systemCalibrations)
  },
  [types.SET_CALIBRATION_PRICING](state, data) {
    state.calibrationPricing = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.calibrationPricing = data
      }
    }
    console.log('Got Calibration Pricing', state.calibrationPricing)
  },
  [types.INIT_BLUEPRINT_INFO_LOOKUP](state) {
    state.blueprintInfoLookup = JSON.parse(JSON.stringify(state.newBlueprintInfoLookup))
    console.log('A new Blueprint Info Lookup', state.blueprintInfoLookup)
  },
  [types.UPDATE_BLUEPRINT_INFO_LOOKUP](state, data) {
    if (state.blueprintInfoLookup !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.blueprintInfoLookup.firm = null
          if (data.value !== null) {
            state.blueprintInfoLookup.firm = parseInt(data.value)
          }
          break
        case 'blueprintInfoLookup':
          state.blueprintInfoLookup.blueprintInfoLookup = null
          if (data.value !== null) {
            state.blueprintInfoLookup.blueprintInfoLookup = parseInt(data.value)
          }
          break
        case 'make':
          state.blueprintInfoLookup.vehicleMake = parseInt(data.value)
          break
        case 'yearStart':
          state.blueprintInfoLookup.yearStart = parseInt(data.value)
          break
        case 'yearEnd':
          state.blueprintInfoLookup.yearEnd = parseInt(data.value)
          break
        case 'title':
          state.blueprintInfoLookup.title = data.value
          break
        case 'description':
          state.blueprintInfoLookup.description = data.value
          break
        case 'url':
          state.blueprintInfoLookup.url = data.value
          break
        case 'isInactive':
          state.blueprintInfoLookup.isInactive = data.value
          break
        case 'sort':
          state.blueprintInfoLookup.sort = parseInt(data.value)
          break
      }
    }
  },
  [types.SET_BLUEPRINT_INFO_LOOKUPS](state, data) {
    state.blueprintInfoLookups = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.blueprintInfoLookups = data
      }
    }
  },
  [types.SET_BLUEPRINT_INFO_LOOKUP](state, data) {
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.blueprintInfoLookup = JSON.parse(JSON.stringify(data))
      }
    }
  },
  [types.SET_BLUEPRINT_INFO_ID](state, data) {
    if (data !== undefined && data !== null) {
      state.blueprintInfoLookup.blueprintInfoLookup = parseInt(data)
    }
  },
  [types.SET_DECODE_SCRUB_RULES](state, data) {
    state.decodeScrubRules = []
    console.log('Setting Decode Scrub Rules', data)
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.decodeScrubRules = data
      }
    }
  },
  [types.SET_DECODE_SCRUB_RULE](state, data) {
    state.decodeScrubRule = null
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.decodeScrubRule = JSON.parse(JSON.stringify(data))
      }
    }
  },
  [types.SET_DECODE_SCRUB_RULE_ID](state, data) {
    if (data !== undefined && data !== null) {
      state.decodeScrubRule.decodeScrubMatrix = parseInt(data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/mutations.js